// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-relative-dates-picker {
  display: flex;
  flex-direction: column;
}
.dl-relative-dates-picker__presets {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.dl-relative-dates-picker__presets-label {
  margin-right: 12px;
}
.dl-relative-dates-picker__presets-select {
  margin-right: 12px;
}
.dl-relative-dates-picker__controls {
  display: flex;
  width: 100%;
}
.dl-relative-dates-picker__control {
  position: relative;
  flex-basis: 100%;
  min-width: 270px;
}
.dl-relative-dates-picker__control .g-radio {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.dl-relative-dates-picker__control-title {
  margin-bottom: 10px;
  font-size: var(--g-text-body-2-font-size);
}
.dl-relative-dates-picker__radiobox-item {
  position: relative;
  display: flex;
  /* .radiobox_size_n sets line-height: 36px for everything,
  that breaks the vertical centering of the calendar */
  line-height: 28px;
}
.dl-relative-dates-picker__radiobox-item-label {
  flex: 0 0 auto;
  margin-right: 12px;
}
.dl-relative-dates-picker__absolute-calendar {
  display: flex;
  position: absolute;
  top: 26px;
  left: 110px;
  width: 174px;
}
.dl-relative-dates-picker__relative-calendar {
  display: flex;
  flex-direction: column;
}
.dl-relative-dates-picker__relative-calendar-row {
  display: flex;
  width: 100%;
}
.dl-relative-dates-picker__relative-calendar-row:not(:first-child) {
  margin-top: 4px;
}
.dl-relative-dates-picker__relative-calendar-date {
  margin-left: 28px;
  color: var(--g-color-text-secondary);
}
.dl-relative-dates-picker__relative-calendar-date_error {
  color: var(--g-color-text-danger);
}
.dl-relative-dates-picker__sign-select {
  width: 88px;
  margin: 0 12px 0 28px;
}
.dl-relative-dates-picker__scale-select {
  display: flex;
  flex: 1 1 auto;
}
.dl-relative-dates-picker__amount-input {
  width: 40px;
}
.dl-relative-dates-picker__amount-input-control {
  border-width: 1px;
}
.dl-relative-dates-picker__error-label {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.dl-relative-dates-picker__error-label-icon {
  margin-right: 4px;
  color: var(--g-color-text-danger);
}
.dl-relative-dates-picker__help-icon {
  margin-left: var(--g-spacing-1);
  vertical-align: middle;
}
.dl-relative-dates-picker .textinput__box {
  border-width: 1px;
}
.dl-relative-dates-picker .radiobox__radio {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/RelativeDatesPicker/RelativeDatesPicker.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AACR;AAEI;EACI,kBAAA;AAAR;AAGI;EACI,kBAAA;AADR;AAII;EACI,aAAA;EACA,WAAA;AAFR;AAKI;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AAHR;AAKQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAHZ;AAOI;EACI,mBAAA;EACA,yCAAA;AALR;AAQI;EACI,kBAAA;EACA,aAAA;EACA;sDAAA;EAEA,iBAAA;AANR;AASI;EACI,cAAA;EACA,kBAAA;AAPR;AAUI;EACI,aAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AATR;AAYI;EACI,aAAA;EACA,sBAAA;AAVR;AAaI;EACI,aAAA;EACA,WAAA;AAXR;AAaQ;EACI,eAAA;AAXZ;AAeI;EACI,iBAAA;EACA,oCAAA;AAbR;AAeQ;EACI,iCAAA;AAbZ;AAiBI;EACI,WAAA;EACA,qBAAA;AAfR;AAkBI;EACI,aAAA;EACA,cAAA;AAhBR;AAmBI;EACI,WAAA;AAjBR;AAoBI;EACI,iBAAA;AAlBR;AAqBI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAnBR;AAsBI;EACI,iBAAA;EACA,iCAAA;AApBR;AAuBI;EACI,+BAAA;EACA,sBAAA;AArBR;AAwBI;EACI,iBAAA;AAtBR;AAyBI;EACI,cAAA;AAvBR","sourcesContent":[".dl-relative-dates-picker {\n  display: flex;\n  flex-direction: column;\n}\n.dl-relative-dates-picker__presets {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.dl-relative-dates-picker__presets-label {\n  margin-right: 12px;\n}\n.dl-relative-dates-picker__presets-select {\n  margin-right: 12px;\n}\n.dl-relative-dates-picker__controls {\n  display: flex;\n  width: 100%;\n}\n.dl-relative-dates-picker__control {\n  position: relative;\n  flex-basis: 100%;\n  min-width: 270px;\n}\n.dl-relative-dates-picker__control .g-radio {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.dl-relative-dates-picker__control-title {\n  margin-bottom: 10px;\n  font-size: var(--g-text-body-2-font-size);\n}\n.dl-relative-dates-picker__radiobox-item {\n  position: relative;\n  display: flex;\n  /* .radiobox_size_n sets line-height: 36px for everything,\n  that breaks the vertical centering of the calendar */\n  line-height: 28px;\n}\n.dl-relative-dates-picker__radiobox-item-label {\n  flex: 0 0 auto;\n  margin-right: 12px;\n}\n.dl-relative-dates-picker__absolute-calendar {\n  display: flex;\n  position: absolute;\n  top: 26px;\n  left: 110px;\n  width: 174px;\n}\n.dl-relative-dates-picker__relative-calendar {\n  display: flex;\n  flex-direction: column;\n}\n.dl-relative-dates-picker__relative-calendar-row {\n  display: flex;\n  width: 100%;\n}\n.dl-relative-dates-picker__relative-calendar-row:not(:first-child) {\n  margin-top: 4px;\n}\n.dl-relative-dates-picker__relative-calendar-date {\n  margin-left: 28px;\n  color: var(--g-color-text-secondary);\n}\n.dl-relative-dates-picker__relative-calendar-date_error {\n  color: var(--g-color-text-danger);\n}\n.dl-relative-dates-picker__sign-select {\n  width: 88px;\n  margin: 0 12px 0 28px;\n}\n.dl-relative-dates-picker__scale-select {\n  display: flex;\n  flex: 1 1 auto;\n}\n.dl-relative-dates-picker__amount-input {\n  width: 40px;\n}\n.dl-relative-dates-picker__amount-input-control {\n  border-width: 1px;\n}\n.dl-relative-dates-picker__error-label {\n  display: flex;\n  align-items: center;\n  margin-top: 15px;\n}\n.dl-relative-dates-picker__error-label-icon {\n  margin-right: 4px;\n  color: var(--g-color-text-danger);\n}\n.dl-relative-dates-picker__help-icon {\n  margin-left: var(--g-spacing-1);\n  vertical-align: middle;\n}\n.dl-relative-dates-picker .textinput__box {\n  border-width: 1px;\n}\n.dl-relative-dates-picker .radiobox__radio {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
